import React, { Component } from "react";
import SimpleDataTable from "../../../../modules/SimpleDataTable";

class PartsTab extends Component {
  tableColumns = [
    {
      name: "",
      label: "No",
      options: {
        customBodyRender: (_, { rowIndex }) => <>{rowIndex + 1}</>,
      },
    },
    {
      name: "kodePart",
      label: "Kode Part",
    },
    {
      name: "namaPart",
      label: "Nama Part",
    },
    {
      name: "kategoriPart",
      label: "Kategori",
    },
    {
      name: "qtyPart",
      label: "Qty",
    },
    {
      name: "qrCodePart",
      label: "QR Code",
    },
  ];

  render() {
    return (
      <SimpleDataTable
        data={this.props.data}
        columns={this.tableColumns}
        rowsPerPage={5}
        options={{ serverSide: false }}
      />
    );
  }
}

export default PartsTab;
